import { ReactNode } from "react";

export enum BB8SystemType {
  OpsPortal = "ops-portal",
  Billing = "billing"
}

export interface IDefaultProps extends IMainPageChildComponent {
  type: BB8SystemType;
  children: ReactNode;
  className?: string;
}

export interface IMainPageChildComponent {
  fullWidth?: boolean;
}

export default BB8SystemType;
